import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ln-share-svg-icon',
  imports: [NgClass],
  templateUrl: './ln-share-svg-icon.component.html',
  styleUrl: './ln-share-svg-icon.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LnShareSvgIconComponent {
  @Input({ required: true }) class!: string;
}
